import { formatDate } from './date';

// Office availability dates are plain yyyy-MM-dd strings, so they compare lexicographically.
export const isOfficeOpenOn = (office: Odoo.Office, date: Date) => {
  const day = formatDate(date);
  return (office.available_from == null || day >= office.available_from) && (office.available_to == null || day <= office.available_to);
};

export const openOfficesOn = (offices: Odoo.Office[], date: Date) =>
  offices.filter(office => isOfficeOpenOn(office, date));

export const isRoomAvailableOn = (room: Odoo.Room, offices: Odoo.Office[], date: Date) => {
  if (!room.office_id) return true;
  const office = offices.find(o => o.id === (room.office_id as [number, string])[0]);
  return office == null || isOfficeOpenOn(office, date);
};
